import { ErrorHandler, Injectable } from '@angular/core';
import { DataSharingService } from '../services/data-sharing.service';

/**
  * This class provide common exception handling method.
  * There are two types of categories
  * (1) Server Error: Server side can be categories:
  *    (a) Recoverable Error: Like Validation, Duplicate, Concurrency, Permission        
  *    (b) Non Recoverable Error: Database Error, Server Code Error
  * (2) Client Error: Client side can be categories:
  *    (a) Recoverable Error: Validation, Permission,         
  *    (b) Non Recoverable Error: Code Error
  * Action taken for diffrent category    
  *    (a) Recoverable Error:  (i) Show message to user        
  *    (b Non Recoverable Error: 
	*	 	    (i) Log on Console 
	*	      (ii) Log on Server
	*		    (iii) Send Error Email based on severity
	*		    (iv) Show Sorry Error Page */
@Injectable()
export class ErrorHandlingService implements ErrorHandler {

  /**
   * Constructor
   * @param _logger: Inject logger
   * @param loginshareservice: Inject Login Share Service
   */
  constructor(private dataSharingService: DataSharingService) {

  }

  /**
   * Un-Handled Exception
   * @param error: Eror object
   */
  public handleError(error) {
    this.dataSharingService.setShowLoader(false);
    console.log(error);
  }

  /**
   * Handled Exception
   * @param error: Error object
   * @param methodName: Method Name
   */
  public handledError(error: Error, methodName: string): string {
    this.dataSharingService.setShowLoader(false);
    // console.log("Error occured in: " + methodName)
    console.log(error);
    return "";
  }


  /**
   * Handle Http Error
   * @param response: http response
   * @param methodName: Method Name
   */
  public handleHttpError(response: any, methodName?: string): string {
    this.dataSharingService.setShowLoader(false);
    console.error("Error occured in API " + methodName)
    console.error(response);
    //this.dataSharingService.setShowLoader(false);
    return "Error occured in API " + methodName;
  }

}









// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/exception/error-handling.service.ts